
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Report your customers' rent payments to Experian, Equifax, and TransUnion using the bank account they've linked via Plaid in your platform"
};
export const partnerProps = {
  partner: 'Boom',
  clientLibrary: 'boom',
  subtitle: metadata.description,
  registrationUrl: 'https://www.boompay.app/rent-reporting-as-a-service',
  apiUrl: 'https://docs.boompay.app/plaid-processor-token-integration',
  isPaymentProcessor: false
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Boom have partnered to offer businesses a secure and streamlined way for customers to build their credit by reporting current and past rent payments to the 3 largest U.S. credit bureaus (Experian, Equifax, and TransUnion). `}</p>
    <p>{`With the Plaid + Boom integration, use Plaid Link to instantly connect customer bank accounts and detect rent payments. Using the Plaid processor token, Boom can detect customer rent payments from accounts customers have already linked directly to your platform. Customers only need to link their bank account once, enabling you to provide rent reporting as a streamlined, convenient amenity to customers.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.TransactionsInstructions {...partnerProps} />
    <Partnership.TransactionsServer {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.TransactionsConclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
